import { Component, Inject, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { InviteService } from 'src/app/services/invite.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { TheNaviGator } from 'src/app/services/the-navi-gator.service';
import { BaseInvitePage } from './base-invite.page';

@Component({
    templateUrl: './invite.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvitePage extends BaseInvitePage {

  override getInviteData(): Promise<Observable<any>> {
    return this.inviteService.getInvite(this.loginIdentifier, this.inviteKey);
  }
  override loginIdentifier: string = this.route.snapshot.paramMap.get('id') ?? "";

  inviteKey: string = this.route.snapshot.paramMap.get('key') ?? "";

  constructor(@Inject(DOCUMENT) override docElements: Document,
    override localStorageService: LocalStorageService,
    override authenticationService: AuthenticationService, protected inviteService: InviteService, override route: ActivatedRoute,
    override navigate: TheNaviGator,
    override oidcSecurityService: OidcSecurityService,
    override sessionStorageService: SessionStorageService) {
    super(docElements, localStorageService, authenticationService, route, navigate, oidcSecurityService, sessionStorageService);
  }

}
